<template>
  <div class="guild-leader-transfer-page">
    <div class="gtp-header-spacer" aria-hidden="true"></div>
    <div class="gtp-header-fixed">
      <div class="gtp-header-inner">
        <img
          class="gtp-back"
          src="../../assets/withdrawal_v2/back2.png"
          alt=""
          @click="goBack"
        />
        <p class="gtp-title">{{ $t("guild_transfer_to_leader") }}</p>
      </div>
    </div>

    <GuildLeaderTransferPanel />
  </div>
</template>

<script>
/**
 * 转移给公会长页 v2 壳层（2026-06-08）
 * 业务逻辑见 guild-leader-transfer-panel.vue
 */
import GuildLeaderTransferPanel from "@/components/withdrawal/guild-leader-transfer-panel.vue";

export default {
  name: "toGuildLeader",
  components: { GuildLeaderTransferPanel },
  // 初始化：向原生环境注册 getUserInfo 回调并设置标题
  created() {
    try {
      // 向原生环境注册回调：暴露 getUserInfo 供 webview 注入用户信息
      this.$completes.complete("getUserInfo");
      window.getUserInfo = this.getUserInfo;
      window["getUserInfo"] = this.getUserInfo;
    } catch (e) {
      /* 浏览器调试 */
    }
    document.title = this.$t("guild_transfer_to_leader");
  },
  methods: {
    // 原生注入用户信息：解析后写入 localStorage
    getUserInfo(data) {
      const userInfo = JSON.parse(data);
      localStorage.setItem("data", JSON.stringify(userInfo));
    },
    // 返回：无上一页时关闭 webview，否则路由返回
    goBack() {
      if (window.history.length <= 1) {
        this.$completes.complete("getPreviousPage");
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style scoped>
.guild-leader-transfer-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
  background: #f5f6f8;
  font-family: "Mada", sans-serif;
}

.guild-leader-transfer-page >>> .gtp-panel {
  flex: 1;
  min-height: 0;
}

.gtp-header-spacer {
  flex-shrink: 0;
  height: calc(88px + env(safe-area-inset-top));
  height: calc(88px + constant(safe-area-inset-top));
}

.gtp-header-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding-top: env(safe-area-inset-top);
  background: #f5f6f8;
}

.gtp-header-inner {
  position: relative;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.gtp-back {
  position: absolute;
  left: 28px;
  top: 50%;
  transform: translateY(-50%);
  width: 64px;
  height: 64px;
}

.gtp-title {
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  color: #262427;
}

html[lang="ar"] .guild-leader-transfer-page {
  direction: rtl;
}

html[lang="ar"] .gtp-back {
  left: auto;
  right: 28px;
  transform: translateY(-50%) rotateY(180deg);
}
</style>
